import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { siteWide } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.ul `
  ${siteWide};
  padding-top: ${fluid(10, 20)};
  padding-bottom: ${fluid(10, 20)};

  &[data-no-mobile='true'] {
    @media ${until(Device.Tablet)} {
      display: none;
    }
  }
`;
const Item = styled.li `
  display: inline;
  margin-right: 12px;
  font-size: 14px;
  line-height: 20px;
  color: ${brand.grey.grey20};

  &:nth-last-child(2),
  &:last-child {
    display: inline;
  }

  @media ${from(Device.Tablet)} {
    display: inline;
    font-size: 20px;
    line-height: 28px;
  }

  svg {
    height: 8px;

    @media ${from(Device.Tablet)} {
      height: 12px;
    }
  }
`;
const ItemLink = styled.a `
  ${fonts.montserrat.regular};

  color: ${brand.black};
  transition: border-color 0.25s ease;
  text-decoration: none;
  border-bottom: 1px solid transparent;
  margin-right: 12px;

  &:hover,
  &:focus {
    border-color: ${brand.black};
    outline: none;
  }
`;
const CurrentItem = styled.span `
  ${fonts.montserrat.medium};
`;
const BreadcrumbStyles = {
    Container,
    Item,
    ItemLink,
    CurrentItem,
};
export default BreadcrumbStyles;
